import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Deshabilitar reintentos automáticos: usar retry(0) para evitar cualquier reintento
    return next.handle(req).pipe(
      retry(0), // Asegurar que no haya reintentos automáticos
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'Ocurrió un error inesperado';

        if (error.error instanceof ErrorEvent) {
          // Error del lado del cliente
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // Error del lado del servidor
          switch (error.status) {
            case 400:
              errorMessage = 'Solicitud incorrecta. Verifica los datos ingresados.';
              break;
            case 401:
              errorMessage = 'Sesión expirada. Por favor, inicia sesión nuevamente.';
              this.handleUnauthorized();
              break;
            case 403:
              errorMessage = 'No tienes permisos para realizar esta acción.';
              this.handleForbidden();
              break;
            case 404:
              errorMessage = 'El recurso solicitado no fue encontrado.';
              break;
            case 409:
              errorMessage = 'Conflicto con el estado actual del recurso.';
              break;
            case 422:
              errorMessage = 'Los datos proporcionados no son válidos.';
              break;
            case 429:
              errorMessage = 'Demasiadas solicitudes. Intenta nuevamente en unos minutos.';
              break;
            case 500:
              errorMessage = 'Error interno del servidor. Intenta nuevamente más tarde.';
              break;
            case 502:
            case 503:
            case 504:
              errorMessage = 'El servicio no está disponible temporalmente.';
              break;
            default:
              errorMessage = `Error ${error.status}: ${error.message}`;
          }
        }

        const handledErrors = [400, 401, 403, 404, 409, 422];

        // Mostrar notificación de error
        if(handledErrors.includes(error.status)) {
          this.notificationService.error(errorMessage);
        } else {
          console.error('Error:', errorMessage);
        }

        return throwError(() => error);
      })
    );
  }

  private handleUnauthorized(): void {
    // Limpiar datos de sesión
    this.authService.logout();
    
    // Redirigir a login
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url }
    });
  }

  private handleForbidden(): void {
    // Redirigir a página de acceso denegado o dashboard
    this.router.navigate(['/unauthorized']);
  }
} 